
import Scorenum from '~/components/common/Scorenum.vue'
import Label from '~/components/common/Label.vue'
export default {
  components: {
    Scorenum,
    Label
  },
  props: {
    detail: {
      type: Object,
      default: () => {}
    },
    index: {
      // 索引
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    lzshow: {
      // 图片是否懒加载
      type: Boolean,
      default: true
    },
    ismore: {
      // label是否有加载更多
      type: Boolean,
      default: true
    },
    num: {
      type: Number,
      default: 0
    }
  },
  data() {
    const _labelsArr = [] 
    this.detail?.labels?.forEach((it) => {
      it?.labels?.forEach((m) => {
      _labelsArr.push(m?.label)
    });
    });
    return {
      value: 0,
      traderIndex: -1,
      selectshow: false,
      labelsArr : _labelsArr,
      labelmore: false
    }
  },
  computed: {
  },
  mounted() {
    console.log('detail', this.detail)
  },
  methods: {
  }
}
